import { Box} from '@mui/material';
import { makeStyles } from '@mui/styles';

import React from 'react';

import ListOfItems from '../ListOfItems';

import ResponseJsonContent from './ResponseJsonContent';

import { RESPONSE_ACTION_MAPPING } from '../applications/constants';

const useStyles = makeStyles(() => ({
    root: {
        '& .listOfItemsCls': {
            marginTop: "0px",
            marginLeft: "30px"
        }
    }
}));
const GuidDetails = ({ guidDetails, responseData, tabInfo, isEditEnabled,jsonContentRef, isCVS }) => {
    const classes = useStyles();

    return (<Box height={`calc(100% - 150px)`} className={classes.root} overflow={"auto"} margin={"10px"} border={"1px solid #cdcbcc"}>
        {guidDetails.map((guidDetail) => {
            return (
                <>
                    <ListOfItems
                        items={[{
                            display: isCVS ? "VIN":"GUID",
                            mapping:  isCVS ? "vin":"guid"
                        }, {
                            display: "CREATED DATE",
                            mapping: "created_date_utc",
                            tooltip: "created_date_local"
                        }, {
                            display: "RESPONSE RECEIVED",
                            mapping: "updated_date_utc",
                            tooltip: "updated_date_local"
                        }, {
                            display: "STATUS",
                            mapping: "status",
                            optionset: RESPONSE_ACTION_MAPPING
                        }, {
                            display: "",
                            type: "empty"
                        }, {
                            display: "",
                            type: "empty"
                        }]}
                        data={guidDetail}
                    />
                    <ResponseJsonContent
                        customHeaderStyles={{
                            border: '1px solid #cdcbcc',
                            height: "auto",
                            overflowY: "hidden"
                        }}
                        responseData={{
                            ...guidDetail,
                            app_name: `${responseData.app_name}_${isCVS ? guidDetail.vin:guidDetail.guid}`
                        }}
                        tabInfo={tabInfo}
                        isEditEnabled={['not_sent','queued'].includes(guidDetail.status) ?  false : isEditEnabled}
                        ref={(el)=>{jsonContentRef.current[isCVS ? guidDetail.vin : guidDetail.guid] = el}}
                        
                    />
                </>
            )
        })}
    </Box>)
}
export default React.memo(GuidDetails);